import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader8.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader8 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo;
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName = branding?.brandName || user?.brandName || "Travel Agency";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // BUILDER MODE
    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    }
    // PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // LIVE MODE
    else {
      // Let <Link> navigate normally
    }

    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.mainWrapper}>

        {/* LOGO BOX */}
        <div className={styles.logoBox}>
        <Link
  to="/"
  onClick={(e) => {
    e.preventDefault(); // 🔥 stops navigation
    handleNavClick(e, { path: "/" });
  }}
>
            {logoUrl ? (
              <img src={logoUrl} alt={brandName} className={styles.logoImage} />
            ) : (
              <h2 className={styles.textLogo}>{brandName}</h2>
            )}
          </Link>
          <div className={styles.cornerBracket}></div>
        </div>

        {/* NAV ISLAND */}
        <nav className={`${styles.navIsland} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            {headerMenu.map((item) => (
              <li key={item.id} className={styles.navItem}>
                <Link
                  to={item.path}
                  onClick={(e) => handleNavClick(e, item)}
                  className={styles.navLink}
                >
                  <span className={styles.navText}>{item.label}</span>
                  <div className={styles.linkIndicator}></div>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* ACTION BOX */}
        <div className={styles.actionBox}>
          <div className={styles.ctaWrapper}>
            <button className={styles.bookBtn}>
              <span className={styles.btnDot}></span>
              Book Now
            </button>
          </div>

          <div
            className={styles.mobileToggle}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>

      </div>

      <div className={styles.bottomStatusLine}></div>
    </header>
  );
};

export default TemplateHeader8;